import { useEffect, useState } from "react";
import axios from "axios";
import { useLanguage } from "../context/LanguageContext";
import { useT } from "../i18n";
import { Clock } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const Schedule = () => {
  const { lang } = useLanguage();
  const t = useT(lang);
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API}/schedule`).then((r) => {
      setItems(r.data);
      setLoading(false);
    }).catch(() => setLoading(false));
  }, []);

  return (
    <div className="py-24 md:py-32">
      <div className="container-wc">
        <div className="max-w-3xl mb-16 fade-up">
          <div className="flex items-center gap-3 mb-4">
            <span className="divider-gold" />
            <span className="eyebrow">{t.nav.schedule}</span>
          </div>
          <h1 className="h-display text-5xl md:text-6xl mb-6">{t.schedule.title}</h1>
          <p className="text-dim text-lg leading-relaxed">{t.schedule.subtitle}</p>
        </div>

        {loading ? (
          <p className="text-dim">Loading...</p>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {items.map((it, i) => (
              <div key={it.id} data-testid={`schedule-${i}`} className="card">
                <div className="flex items-start justify-between mb-4">
                  <div>
                    <span className="eyebrow">{lang === "el" ? it.day_el : it.day_en}</span>
                    <h3 className="font-serif text-2xl mt-2">{lang === "el" ? it.title_el : it.title_en}</h3>
                  </div>
                  <div className="flex items-center gap-2 text-gold text-sm">
                    <Clock size={14} /> {it.time}
                  </div>
                </div>
                <p className="text-dim text-sm leading-relaxed">
                  {lang === "el" ? it.description_el : it.description_en}
                </p>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default Schedule;
